/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_EmptyInputs */

const en_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No upcoming events at this time.`)
};

const es_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay eventos próximos en este momento.`)
};

const de_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurzeit keine bevorstehenden Veranstaltungen.`)
};

const zh_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前没有即将举行的活动。`)
};

const ar_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد فعاليات قادمة في هذا الوقت.`)
};

const fr_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement à venir pour le moment.`)
};

const vi_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện không có sự kiện sắp tới.`)
};

const sw_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna matukio yanayokuja kwa wakati huu.`)
};

const th_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีกิจกรรมที่กำลังจะเกิดขึ้นในขณะนี้`)
};

const bs_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenutno nema predstojećih događaja.`)
};

const ja_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在予定されているイベントはありません。`)
};

const ko_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 예정된 이벤트가 없습니다.`)
};

const pt_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há eventos programados no momento.`)
};

const it_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento imminente in questo momento.`)
};

const sv_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga kommande evenemang just nu.`)
};

const nl_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momenteel geen komende evenementen.`)
};

const da_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen kommende arrangementer lige nu.`)
};

const nb_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen kommende arrangementer for øyeblikket.`)
};

const fi_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tulevia tapahtumia tällä hetkellä.`)
};

const pl_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak nadchodzących wydarzeń.`)
};

const ru_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сейчас нет предстоящих мероприятий.`)
};

const tr_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu anda planlanmış etkinlik yok.`)
};

const hi_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस समय कोई आगामी कार्यक्रम नहीं।`)
};

const id_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada acara yang akan datang saat ini.`)
};

const ms_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada acara akan datang buat masa ini.`)
};

const cs_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentálně nejsou naplánované žádné akce.`)
};

const el_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν υπάρχουν προσεχείς εκδηλώσεις αυτή τη στιγμή.`)
};

const he_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין אירועים קרובים כרגע.`)
};

const af_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen komende geleenthede op die oomblik nie.`)
};

const hu_events_empty = /** @type {(inputs: Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelenleg nincs közelgő esemény.`)
};

/**
* | output |
* | --- |
* | "No upcoming events at this time." |
*
* @param {Events_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_empty = /** @type {((inputs?: Events_EmptyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_EmptyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_empty(inputs)
	if (locale === "de") return de_events_empty(inputs)
	if (locale === "zh") return zh_events_empty(inputs)
	if (locale === "ar") return ar_events_empty(inputs)
	if (locale === "fr") return fr_events_empty(inputs)
	if (locale === "vi") return vi_events_empty(inputs)
	if (locale === "sw") return sw_events_empty(inputs)
	if (locale === "th") return th_events_empty(inputs)
	if (locale === "bs") return bs_events_empty(inputs)
	if (locale === "ja") return ja_events_empty(inputs)
	if (locale === "ko") return ko_events_empty(inputs)
	if (locale === "pt") return pt_events_empty(inputs)
	if (locale === "it") return it_events_empty(inputs)
	if (locale === "sv") return sv_events_empty(inputs)
	if (locale === "nl") return nl_events_empty(inputs)
	if (locale === "da") return da_events_empty(inputs)
	if (locale === "nb") return nb_events_empty(inputs)
	if (locale === "fi") return fi_events_empty(inputs)
	if (locale === "pl") return pl_events_empty(inputs)
	if (locale === "ru") return ru_events_empty(inputs)
	if (locale === "tr") return tr_events_empty(inputs)
	if (locale === "hi") return hi_events_empty(inputs)
	if (locale === "id") return id_events_empty(inputs)
	if (locale === "ms") return ms_events_empty(inputs)
	if (locale === "cs") return cs_events_empty(inputs)
	if (locale === "el") return el_events_empty(inputs)
	if (locale === "he") return he_events_empty(inputs)
	if (locale === "af") return af_events_empty(inputs)
	if (locale === "hu") return hu_events_empty(inputs)
	return en_events_empty(inputs)
});